var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { StoreContext } from '../uistore/Rootstore';
import { Button, Box, FormControl, FormLabel, Flex, Input, Center, Container, Text, FormErrorMessage, FormHelperText, InputGroup, InputRightElement, Select } from '@chakra-ui/react';
import { Greetings } from './GreetingView';
import { AppColor } from '../const/AppDefaults';
import { LoginTypes } from '@@/LoginDetails';
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight';
import { RegisterStage } from '@/share/models';
import { checkPasswordStrength, emailStringVerify, testIsMobile } from '@@/Util';
import { Observer, observer } from 'mobx-react';
import { Loading } from '../components/Loading';
import { APPEvent } from '@/events/AppEvents';
import { AppState } from '@/share/AppState';
import { ProgressBar } from '../UIComponents/ProgressBar';
import { LetrwingCrypto } from '@@/LetrwingCommonCrypto';
let Register = class Register extends React.Component {
    constructor() {
        super(...arguments);
        this.resending = false;
    }
    componentWillUnmount() {
        const rstore = this.context;
        rstore.registerStore.reset();
    }
    verifyPin() {
        const rstore = this.context;
        if (!rstore.registerStore.passcode) {
            return;
        }
        rstore.registerStore.verifyPin();
    }
    resendCode() {
        if (this.resending) {
            return;
        }
        this.resending = true;
        const rstore = this.context;
        rstore.registerStore.resendCode();
        APPEvent.publishApperror("Code sent");
        this.resending = false;
    }
    register() {
        const rstore = this.context;
        if (!rstore.registerStore.email && !rstore.registerStore.orgcode) {
            APPEvent.publishApperror("Please enter email or organisation code to register");
            return;
        }
        else if (rstore.registerStore.email && rstore.registerStore.orgcode) {
            APPEvent.publishApperror("Please enter either email or organisation code to register");
            return;
        }
        else if (rstore.registerStore.email && !emailStringVerify(rstore.registerStore.email)) {
            APPEvent.publishApperror("Please eneter valid email id");
            return;
        }
        rstore.registerStore.register();
    }
    // UI for this should look like 
    // You have been invited to join {org name or drop down}
    // once picked register 
    // get info and get user info
    //  
    orgselected(sel) {
        const rstore = this.context;
        rstore.registerStore.selectedRegsiterOrg(sel);
    }
    createNewOrg() {
        const rstore = this.context;
        rstore.registerStore.setRegisterStage(RegisterStage.NewUser);
    }
    regsiterUserToOrg() {
        const rstore = this.context;
        rstore.registerStore.newOrgState.setNameError("");
        if (!rstore.registerStore.newOrgState.password || !checkPasswordStrength(rstore.registerStore.newOrgState.password)) {
            rstore.registerStore.newOrgState.setPasscodeError("Please enter the valid password");
            return;
        }
        rstore.registerStore.newOrgState.setPasscodeError("");
        rstore.registerStore.newOrgState.setSecret(LetrwingCrypto.getRandomPassword());
        /* if (!rstore.registerStore.newOrgState.secret || !checkPasswordStrength(rstore.registerStore.newOrgState.secret)) {
             rstore.registerStore.newOrgState.setSecretError("Please enter the valid secret");
             return;
         }*/
        rstore.registerStore.newOrgState.setSecretError("");
        rstore.registerStore.newOrgState.setOrgError("");
        rstore.registerStore.registerUserToOrg();
        // now lets register this user!
    }
    regsiterTorOrg() {
        const rstore = this.context;
        if (!rstore.registerStore.selectedregisterorg.trim()) {
            return;
        }
        const org = rstore.registerStore.verifiedReg.invitesorg.filter((or) => or.id === rstore.registerStore.selectedregisterorg.trim());
        if (org !== undefined && org.length > 0) {
            rstore.registerStore.newOrgState.setOrgname(org[0].name);
            rstore.registerStore.acceptedorgname = org[0].name;
        }
        rstore.registerStore.acceptInvite();
    }
    buildRegisterUser() {
        const rstore = this.context;
        return React.createElement(Box, { paddingLeft: '10px', paddingRight: '10px' },
            React.createElement(FormControl, { mt: '10px', isRequired: true, isInvalid: rstore.registerStore.newOrgState.passcodeerror.length > 0 ? true : false },
                React.createElement(FormLabel, { style: { color: AppColor.GreetingMessage, fontSize: '12px' }, htmlFor: "password" }, "Password"),
                React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, type: 'password', value: rstore.registerStore.newOrgState.password, onChange: (e) => rstore.registerStore.newOrgState.setPassword(e.currentTarget.value), id: "password", placeholder: "Password" }),
                React.createElement(FormHelperText, { style: { color: AppColor.GreetingMessage, fontSize: '12px' } }, "Login password is your password for the app. Password should be minimum 6 characters long and must contain atleast one number, one special character"),
                React.createElement(FormErrorMessage, { style: { color: AppColor.PasswordMessage, fontSize: '12px' } }, rstore.registerStore.newOrgState.passcodeerror)),
            React.createElement(Center, { flexDirection: 'column' },
                React.createElement(Box, null,
                    React.createElement(Button, { colorScheme: 'lwcolor', disabled: !rstore.registerStore.selectedregisterorg.trim() ? true : false, w: '200px', mt: '15px', onClick: () => this.regsiterUserToOrg(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Register")),
                React.createElement(Button, { mt: '10px', onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Restart")));
    }
    buildRegisterForOrg() {
        const rstore = this.context;
        return React.createElement(Box, { paddingLeft: '10px', paddingRight: '10px' },
            React.createElement(Box, null,
                rstore.registerStore.verifiedReg.invitesorg.length === 1 &&
                    React.createElement(Text, { fontSize: '14px', color: AppColor.GreetingMessage }, 'You have been invited to join ' + rstore.registerStore.verifiedReg.invitesorg[0].name + '. You can either accept the invitation or create your own organisation.'),
                rstore.registerStore.verifiedReg.invitesorg.length > 1 && React.createElement(Box, null,
                    React.createElement(Text, { fontSize: '14px', color: AppColor.GreetingMessage }, 'You have been invited to join below organisations.'),
                    React.createElement(Text, { fontSize: '14px', color: AppColor.GreetingMessage }, 'Either accept invitation from one of them or create your own organisation.'),
                    React.createElement(Observer, null, () => React.createElement(Select, { bg: 'white', onChange: (e) => this.orgselected(e.currentTarget.value), placeholder: "Select Organisation" }, rstore.registerStore.verifiedReg.invitesorg.map(org => React.createElement("option", { onSelect: () => this.orgselected(org.id), key: org.id, value: org.id }, org.name))))),
                React.createElement(Center, { flexDirection: 'column' },
                    React.createElement(Box, null,
                        React.createElement(Button, { colorScheme: 'lwcolor', disabled: !rstore.registerStore.selectedregisterorg.trim() ? true : false, w: '200px', mt: '15px', onClick: () => this.regsiterTorOrg(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Register")),
                    React.createElement(Button, { mt: '10px', onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Restart"))));
    }
    buildRegisterDevice() {
        const rstore = this.context;
        return React.createElement(Container, null,
            React.createElement(Box, null,
                React.createElement(InputGroup, { size: "md" },
                    React.createElement(Input
                    // style={{ color: 'lightgray' }}
                    , { 
                        // style={{ color: 'lightgray' }}
                        focusBorderColor: AppColor.HeaderIconColor, variant: "outline", placeholder: "Password", type: rstore.registerStore.showRegisterDevicePassword ? "text" : "password", value: rstore.registerStore.newOrgState.password, onChange: (e) => rstore.registerStore.newOrgState.setPassword(e.currentTarget.value) }),
                    React.createElement(InputRightElement, { width: "4.5rem" },
                        React.createElement(Button, { h: "1.75rem", size: "sm", onClick: () => rstore.registerStore.toggleShowRegisterDevicePassword(), colorScheme: 'lwcolor' }, rstore.registerStore.showRegisterDevicePassword ? "Hide" : "Show")))));
    }
    buildEmail() {
        const rstore = this.context;
        return React.createElement(Container, null,
            React.createElement(Box, null,
                React.createElement(Input
                // borderBottomColor={rstore.registerStore.orgcode ? "inherit" : "#a5a5a5"}
                // style={{ color: 'lightgray' }}
                , { 
                    // borderBottomColor={rstore.registerStore.orgcode ? "inherit" : "#a5a5a5"}
                    // style={{ color: 'lightgray' }}
                    focusBorderColor: AppColor.HeaderIconColor, variant: "outline", disabled: rstore.registerStore.orgcode ? true : false, placeholder: "Email", value: rstore.registerStore.email, onChange: (e) => rstore.registerStore.setEmail(e.currentTarget.value) })));
    }
    buldSSO() {
        return React.createElement(Container, null,
            React.createElement(Flex, { alignItems: 'center', justifyContent: 'center' },
                React.createElement(Button, { size: 'sm', color: 'lightgray', backgroundColor: AppColor.Default, variant: "solid" }, "Single Sign On")));
    }
    buildOrg() {
        const rstore = this.context;
        return React.createElement(Container, { mt: '20px' },
            React.createElement(Box, null,
                React.createElement(Input, { borderBottomColor: rstore.registerStore.email ? "inherit" : "#a5a5a5", style: { color: '#FFFFFF' }, variant: "outline", disabled: rstore.registerStore.email ? true : false, placeholder: "Organisation Code", value: rstore.registerStore.orgcode, onChange: (e) => rstore.registerStore.setOrgCode(e.currentTarget.value) })));
    }
    buildOr() {
        return React.createElement(Container, { mt: '20px' },
            React.createElement(Box, { textAlign: 'center', color: AppColor.GreetingMessage }, "OR"));
    }
    buildNewUserVerifyScreen() {
        const rstore = this.context;
        return React.createElement(Box, null,
            React.createElement(Box, { textAlign: 'center' },
                React.createElement(Text, { color: AppColor.GreetingMessage }, "Please enter the OTP that has been sent to your email address.")),
            React.createElement(Container, { maxW: '280px', mt: '20px' },
                React.createElement(Box, null,
                    React.createElement(Input, { type: 'password', 
                        // style={{ color: 'lightgray' }}
                        focusBorderColor: AppColor.HeaderIconColor, variant: "outline", placeholder: "Verify Passcode", value: rstore.registerStore.passcode, onChange: (e) => rstore.registerStore.setPasscode(e.currentTarget.value) }))));
    }
    restart() {
        const rstore = this.context;
        rstore.registerStore.reset();
        APPEvent.publishAppState(AppState.Unknown);
    }
    buildOrgRegistered() {
        const rstore = this.context;
        const orgname = rstore.registerStore.newOrgState.orgname;
        return React.createElement(Container, null,
            React.createElement(Box, { textAlign: 'center' },
                React.createElement(Text, { color: AppColor.GreetingMessage, fontSize: '18px' }, "Created " + orgname + " secure platform."),
                React.createElement(Text, { color: AppColor.GreetingMessage, fontSize: '18px', mt: '15px' }, 'Master password'),
                React.createElement(Text, { color: AppColor.MasterPassword, mt: '25px', fontWeight: 'bold', fontSize: '20px', style: { wordWrap: 'normal' } }, rstore.registerStore.masterPassword),
                React.createElement(Text, { color: AppColor.PasswordMessage, mt: '15px', fontSize: '14px' }, "Please make sure to copy and securely save the master password before proceeding." +
                    "This will be required for managing and accessing your secure platform admin features" +
                    "like user management, device managements etc."),
                React.createElement(Text, { mt: '20px', fontWeight: 'bold', fontSize: '14px', color: AppColor.PasswordMessage }, "Please note that we wont be able to recover this key or your data if this key is lost.")));
    }
    buildNewUser() {
        const rstore = this.context;
        return React.createElement(Box, { paddingLeft: '10px', paddingRight: '10px' },
            React.createElement(FormControl, { isRequired: true, isInvalid: rstore.registerStore.newOrgState.nameerror.length > 0 ? true : false },
                React.createElement(FormLabel, { style: { color: AppColor.GreetingMessage, fontSize: '12px' }, htmlFor: "name" }, "Name"),
                React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, value: rstore.registerStore.newOrgState.name, onChange: (e) => rstore.registerStore.newOrgState.setName(e.currentTarget.value), id: "name", placeholder: "Name" }),
                React.createElement(FormErrorMessage, null, rstore.registerStore.newOrgState.nameerror)),
            React.createElement(FormControl, { mt: '10px', isRequired: true, isInvalid: rstore.registerStore.newOrgState.passcodeerror.length > 0 ? true : false },
                React.createElement(FormLabel, { style: { color: AppColor.GreetingMessage, fontSize: '12px' }, htmlFor: "password" }, "Password"),
                React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, type: 'password', value: rstore.registerStore.newOrgState.password, onChange: (e) => rstore.registerStore.newOrgState.setPassword(e.currentTarget.value), id: "password", placeholder: "Password" }),
                React.createElement(FormHelperText, { style: { color: AppColor.GreetingMessage, fontSize: '12px' } }, "Login password is your password for the app. Password should be minimum 6 characters long and must contain atleast one number, one special character"),
                React.createElement(FormErrorMessage, null, rstore.registerStore.newOrgState.passcodeerror)),
            React.createElement(FormControl, { mt: '10px', isRequired: true, isInvalid: rstore.registerStore.newOrgState.orgerror.length > 0 ? true : false },
                React.createElement(FormLabel, { style: { color: AppColor.GreetingMessage, fontSize: '12px' }, htmlFor: "orgname" }, "Organisation Name"),
                React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, value: rstore.registerStore.newOrgState.orgname, onChange: (e) => rstore.registerStore.newOrgState.setOrgname(e.currentTarget.value), id: "orgname", placeholder: "Organisation Name" }),
                React.createElement(FormErrorMessage, null, rstore.registerStore.newOrgState.orgerror)));
    }
    setupDevice() {
        const rstore = this.context;
        rstore.registerStore.registerThisDevice();
    }
    registerOrg() {
        const rstore = this.context;
        if (!rstore.registerStore.newOrgState.name) {
            rstore.registerStore.newOrgState.setNameError("Please enter the name");
            return;
        }
        rstore.registerStore.newOrgState.setNameError("");
        if (!rstore.registerStore.newOrgState.password || !checkPasswordStrength(rstore.registerStore.newOrgState.password)) {
            rstore.registerStore.newOrgState.setPasscodeError("Please enter the valid password");
            return;
        }
        rstore.registerStore.newOrgState.setPasscodeError("");
        rstore.registerStore.newOrgState.setSecret(LetrwingCrypto.getRandomPassword());
        if (!rstore.registerStore.newOrgState.secret || rstore.registerStore.newOrgState.secret.length < 4) {
            rstore.registerStore.newOrgState.setSecretError("Recovery password should be minimum 4 characters long.");
            return;
        }
        rstore.registerStore.newOrgState.setSecretError("");
        if (!rstore.registerStore.newOrgState.orgname) {
            rstore.registerStore.newOrgState.setOrgError("Please enter the organisation name");
            return;
        }
        rstore.registerStore.newOrgState.setOrgError("");
        rstore.registerStore.newOrgRegister();
    }
    startApp() {
        const rstore = this.context;
        const orgname = rstore.registerStore.newOrgState.orgname;
        const password = rstore.registerStore.newOrgState.password;
        const mpwd = rstore.registerStore.masterPassword;
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(rstore.registerStore.masterPassword));
        element.setAttribute('download', "letrwing_" + orgname + "_masterpassword.txt");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        rstore.confirmStore.setMessage("Please make sure to copy and save master password before continuing. This password will enable you to recover data and manage users. If you haven't copied the password press cancel to copy the password.");
        rstore.confirmStore.setOkCB(() => {
            APPEvent.publishAppState(AppState.Login);
            rstore.loginViewStore.loginDeviceExternal(password, mpwd);
        });
        rstore.confirmStore.setOpen(true);
    }
    setRegisterViaDevice() {
        const rstore = this.context;
        rstore.authStore.setShowLoginViaDevice(true);
    }
    forgotPassword() {
        const rstore = this.context;
        rstore.authStore.setAppState(AppState.ResetPassword);
    }
    render() {
        const rstore = this.context;
        const registerTypes = rstore.authStore.registerTypes;
        const org = registerTypes.indexOf(LoginTypes.OrgCode) !== -1;
        const email = registerTypes.indexOf(LoginTypes.Email) !== -1;
        const sso = registerTypes.indexOf(LoginTypes.SSO) !== -1;
        return (React.createElement(Center, null,
            React.createElement(Box, { mt: '5%', h: testIsMobile() ? (window.innerHeight - 100) + "px" : (window.innerHeight - 150) + "px", className: 'login-container', width: testIsMobile() ? window.innerWidth - 50 + "px" : '600px' },
                React.createElement(Greetings, null),
                rstore.registerStore.registerStage === RegisterStage.Processing && React.createElement(Box, null,
                    React.createElement(Loading, { color: AppColor.GreetingMessage, message: 'Verifying...' })),
                rstore.registerStore.registerStage === RegisterStage.Register && React.createElement(Box, null,
                    React.createElement(FormControl, { key: 'Email', id: "email" },
                        sso && this.buldSSO(),
                        sso && email && this.buildOr(),
                        email && this.buildEmail()),
                    (email || org) && React.createElement(Container, { mt: '30px' },
                        React.createElement(Flex, { alignItems: 'center', justifyContent: 'center' },
                            React.createElement(Button, { colorScheme: 'lwcolor', onClick: () => this.register(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Get Started")),
                        React.createElement(Flex, { alignItems: 'center', justifyContent: 'center' },
                            React.createElement(Button, { onClick: () => this.forgotPassword(), mt: '15px', size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Forgotten Password?")))),
                rstore.registerStore.registerStage === RegisterStage.RegisterForOrg
                    && this.buildRegisterForOrg(),
                rstore.registerStore.registerStage === RegisterStage.RegsiterUserToOrg
                    && this.buildRegisterUser(),
                rstore.registerStore.registerStage === RegisterStage.NewUserPinVerify &&
                    React.createElement(Box, null,
                        this.buildNewUserVerifyScreen(),
                        React.createElement(Flex, { mt: '15px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' },
                            React.createElement(Button, { colorScheme: 'lwcolor', disabled: rstore.registerStore.passcode ? false : true, onClick: () => this.verifyPin(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Verify Pin"),
                            React.createElement(Button, { mt: '10px', onClick: () => this.resendCode(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Resend Code"),
                            React.createElement(Button, { mt: '10px', onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Restart"))),
                rstore.registerStore.registerStage === RegisterStage.PinVerify &&
                    React.createElement(Box, null,
                        this.buildNewUserVerifyScreen(),
                        React.createElement(Flex, { mt: '15px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' },
                            React.createElement(Button, { colorScheme: 'lwcolor', disabled: rstore.registerStore.passcode ? false : true, onClick: () => this.verifyPin(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Verify Pin"),
                            React.createElement(Button, { mt: '10px', onClick: () => this.resendCode(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Resend Code"),
                            React.createElement(Button, { mt: '10px', onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Restart"))),
                rstore.registerStore.registerStage === RegisterStage.NewUser && React.createElement(Box, null,
                    this.buildNewUser(),
                    React.createElement(Flex, { mt: '15px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' },
                        React.createElement(Button, { colorScheme: 'lwcolor', disabled: rstore.registerStore.newOrgState.name && rstore.registerStore.newOrgState.password &&
                                rstore.registerStore.newOrgState.orgname ? false : true, onClick: () => this.registerOrg(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Register"),
                        React.createElement(Button, { mt: '10px', onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Restart"))),
                (rstore.registerStore.registerStage === RegisterStage.Securing || rstore.registerStore.registerStage === RegisterStage.ProgressError) && React.createElement(Box, null,
                    rstore.registerStore.registerStage === RegisterStage.Securing && React.createElement(ProgressBar, { state: rstore.registerStore.progressstate }),
                    rstore.registerStore.registerStage === RegisterStage.ProgressError && React.createElement(Box, null,
                        React.createElement(Center, { mt: '15px' },
                            React.createElement(Text, { color: AppColor.GreetingMessage }, rstore.registerStore.progressstate.progessMessage)),
                        " ",
                        React.createElement(Flex, { mt: '15px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' },
                            React.createElement(Button, { mt: '10px', onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Restart")))),
                rstore.registerStore.registerStage === RegisterStage.RegisterDevice && React.createElement(Box, null,
                    this.buildRegisterDevice(),
                    React.createElement(Flex, { mt: '15px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' },
                        React.createElement(Button, { colorScheme: 'lwcolor', disabled: rstore.registerStore.newOrgState.password ? false : true, onClick: () => this.setupDevice(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Setup Device"),
                        React.createElement(Button, { mt: '10px', onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: 'link' }, "Restart"))),
                rstore.registerStore.registerStage === RegisterStage.ShowOrgCreated && React.createElement(Box, null,
                    this.buildOrgRegistered(),
                    rstore.registerStore.failedsecuringdevice && React.createElement(Text, { color: 'red' }, "Sorry, failed to secure this device. Please try securing this device again using retsart option. "),
                    React.createElement(Flex, { mt: '15px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' },
                        !rstore.registerStore.failedsecuringdevice && React.createElement(Button, { onClick: () => this.startApp(), rightIcon: React.createElement(FiArrowRight, null), size: 'sm', variant: "solid" }, "Start"),
                        rstore.registerStore.failedsecuringdevice && React.createElement(Button, { onClick: () => this.restart(), size: 'sm', color: AppColor.LoginButtonIconColor, variant: "link" }, "Restart"))))));
    }
};
Register.contextType = StoreContext;
Register = __decorate([
    observer
], Register);
export { Register };
